<template>
  <div>
    <tplheader></tplheader>
    <tplLeftPanel></tplLeftPanel>
    <div id="fixed-top-menu-outer" class="fixed-top-menu-outer">
      <div class="fixed-top-menu">
        <div class="pull-right">
          <ajaxLoaderButton v-if="form.card.status_id != 8 && $root.checkRule('card/edit/create')" :onClick="save" iconclass="fa fa-save" label="Ment" v-model="is_save"/>
          <ajaxLoaderButton v-if="form.card.status_id == 3 && $root.checkRule('card/edit/create')" :onClick="enrollmentConfirmationPrint" iconclass="fa fa-paper-plane-o" label="Igénylési igazolás" v-model="is_print_enroll"/>
          <ajaxLoaderButton  v-if="form.card.status_id == 3 && $root.checkRule('card/edit/print')" :onClick="print" iconclass="fa fa-print" label="Nyomtat" v-model="is_print"/>
          <button v-if="form.card.status_id == 5 && $root.checkRule('card/edit/print') && cert_file_exists" class="btn btn-primary" type="button" v-on:click="printBizonylat"><i class="fa fa-print"></i>Bizonylat nyomtat</button>
          <button v-if="(form.card.status_id == 9 || form.card.status_id == 10) && $root.checkRule('card/edit/allow')" class="btn btn-primary" type="button" v-on:click="changeCardStatus(3)"><i class="fa fa-thumbs-o-up"></i>Igénylés elfogadás</button>
          <button v-if="(form.card.status_id == 5 || form.card.status_id == 7) && $root.checkRule('card/edit/ban')" class="btn btn-primary" type="button" v-on:click="changeCardStatus(8)"><i class="fa fa-times"></i>Letiltás</button>
          <button v-if="form.card.status_id == 5 && $root.checkRule('card/edit/suspend')" class="btn btn-primary" type="button" v-on:click="changeCardStatus(7)"><i class="fa fa-thumbs-o-down"></i>Felfüggesztés</button>
          <button v-if="(form.card.status_id == 7 || form.card.status_id == 11) && $root.checkRule('card/edit/activate')" class="btn btn-primary" type="button" v-on:click="changeCardStatus(5)"><i class="fa fa-thumbs-o-up"></i>Aktíválás</button>
          <button v-if="form.card.status_id == 4 && $root.checkRule('card/edit/waste')" class="btn btn-primary" type="button" v-on:click="changeCardStatus(8)"><i class="fa fa-trash"></i>Selejt (Letiltás)</button>
        </div>
      </div>
    </div>

    <div id="main-panel" class="main-panel">
      <div class="content-panel">
        <ul class="breadcrumb">
          <li>Kezdőőoldal</li>
          <li>Kártyák</li>
          <li>Kártya</li>
        </ul>
        <div class="page-title">
          <h1><i class="material-icons">chevron_right</i>Kártya</h1>
        </div>
        <div class="content-panel-top-btn-group">
          <ajaxLoaderButton v-if="form.card.status_id != 8 && $root.checkRule('card/edit/create')" :onClick="save" iconclass="fa fa-save" label="Ment" v-model="is_save"/>
          <ajaxLoaderButton v-if="form.card.status_id == 3 && $root.checkRule('card/edit/create')" :onClick="enrollmentConfirmationPrint" iconclass="fa fa-paper-plane-o" label="Igénylési igazolás" v-model="is_print_enroll"/>
          <ajaxLoaderButton v-if="form.card.status_id == 3 && $root.checkRule('card/edit/print')" :onClick="print" iconclass="fa fa-print" label="Nyomtat" v-model="is_print"/>
          <button v-if="form.card.status_id == 5 && $root.checkRule('card/edit/print') && cert_file_exists" class="btn btn-primary" type="button" v-on:click="printBizonylat"><i class="fa fa-print"></i>Bizonylat nyomtat</button>
          <button v-if="(form.card.status_id == 9 || form.card.status_id == 10) && $root.checkRule('card/edit/allow')" class="btn btn-primary" type="button" v-on:click="changeCardStatus(3)"><i class="fa fa-thumbs-o-up"></i>Igénylés elfogadás</button>
          <button v-if="(form.card.status_id == 5 || form.card.status_id == 7) && $root.checkRule('card/edit/ban')" class="btn btn-primary" type="button" v-on:click="changeCardStatus(8)"><i class="fa fa-times"></i>Letiltás</button>
          <button v-if="(form.card.status_id == 5 || form.card.status_id == 11) && $root.checkRule('card/edit/suspend')" class="btn btn-primary" type="button" v-on:click="changeCardStatus(7)"><i class="fa fa-thumbs-o-down"></i>Felfüggesztés</button>
          <button v-if="(form.card.status_id == 7 || form.card.status_id == 11) && $root.checkRule('card/edit/activate')" class="btn btn-primary" type="button" v-on:click="changeCardStatus(5)"><i class="fa fa-thumbs-o-up"></i>Aktíválás</button>
          <button v-if="form.card.status_id == 4 && $root.checkRule('card/edit/waste')" class="btn btn-primary" type="button" v-on:click="changeCardStatus(8)"><i class="fa fa-trash"></i>Selejt (Letiltás)</button>
        </div>
        <div class="panel">
          <div class="panel-heading">
            <h4>Kártya</h4>
          </div>
          <form enctype="multipart/form-data">
            <div class="panel-body">
              <div class="row">
                <div class="col-xs-6">
                  <div class="panel-sub-heading"><h4>Adatok</h4></div>
                    <div v-if="(form.card.status_id == 9 || form.card.status_id == 10)" class="form-group">
                      <label class="form-label">Fotó</label>
                      <div class="row">
                        <div class="col-xs-6">
                          <img style="width: 100%; height: auto" :src="form.card.owner_photo">
                        </div>
                        <div class="col-xs-6">
                          <textareabox cstyle="height: 150px" id="photo_email" label="Email" v-bind:errors="errors" name="photo_email" v-model="photo_email"></textareabox>
                          <button v-if="form.card.status_id == 9" v-on:click="badPhotoEmailSend" type="button" class="btn btn-primary"><i class="fa fa-envelope"></i>Email küldés</button>
                          <button v-else v-on:click="badPhotoEmailSend" type="button" class="btn btn-primary"><i class="fa fa-envelope"></i>Email újraküldés</button>
                        </div>
                      </div>
                    </div>

                    <ul style="padding-bottom: 15px" class="tree" v-if="owner.neptundata != undefined && owner.show_student_status">
                      <li v-for="nd in owner.neptundata">
                        <i class="fa fa-graduation-cap"></i>
                        {{ nd.SZAK_MEGN }} ({{ nd.SZAKKOD }}) - {{ nd.TAGOZAT }} - <span style="font-weight: 600">{{ nd.STATUSZ }}</span>
                      </li>
                    </ul>

                    <div class="alert alert-info" v-if="owner.kollegiumi_szoba != undefined">
                      Kollégiumi szoba: {{ owner.kollegiumi_szoba }}
                    </div>

                    <div class="alert alert-info" v-if="owner.felvetelt_nyert_kollegium != false">
                      Felvételt nyert kollégium: <strong>{{ owner.felvetelt_nyert_kollegium.kollegium }}</strong> ({{ owner.felvetelt_nyert_kollegium.idoszak }})
                    </div>

                    <div class="alert alert-info" v-if="owner.golyahet != undefined && owner.golyahet">
                      Gólyahétre jönne
                    </div>

                    <select2ajax url="card_owner/search" :disabled="(this.form.card.id != 0 || this.form.card.owner_id != 0) ? true : false" :change="ownerChange" id="owner_id" label="Kártyabirtokos" v-bind:errors="errors" name="owner_id" v-model="form.owners"></select2ajax>
                    <inputbox disabled="true" id="card_number" label="Kártyaszám" v-bind:errors="errors" name="username" v-model="form.card.card_number"></inputbox>
                    <inputbox v-show="false" id="chip_id" label="Chip ID" v-bind:errors="errors" name="chip_id" v-model="form.card.chip_id"></inputbox>
                    <div v-show="form.card.status_id == 4" class="row" style="display:none">
                      <div class="col-xs-6">
                        <inputbox disabled="true" id="rf_id" label="RF ID" v-bind:errors="errors" name="rf_id" v-model="form.card.rf_id"></inputbox>
                      </div>
                      <div class="col-xs-6">
                        <button v-show="!this.form.card.rf_id && $root.checkRule('card/edit/rfread')" v-on:click="rfpopupShow" style="margin-top:15px; display:none" class="btn btn-white" type="button"><i class="fa fa-id-card-o"></i>RF beolvasása</button>
                      </div>
                    </div>
                    <inputbox v-if="this.form.card.rf_id != '' && (this.form.card.status_id == 5 || this.form.card.status_id == 7 || this.form.card.status_id == 8)" disabled="disabled" id="show_rf_id" label="RF ID" name="show_rf_id" v-model="form.card.rf_id"></inputbox>
                    <combobox disabled="true" :change="statusChange" id="status_id" label="Státusz" v-bind:errors="errors" name="status_id" v-model="form.statuses"></combobox>
                    <inputbox inputCheck="ad_username" :disabled="!this.ad_canedit" id="ad_username" label="AD felh.név" v-bind:errors="errors" name="ad_username" v-model="form.card.owner_ad_username"></inputbox>
                    <toggle v-if="form.card.remanufactured != undefined" id="remanufactured" label="Újragyártott" name="remanufactured" v-model="form.card.remanufactured"></toggle>
                </div>
                <div class="col-xs-6">
                  <div class="panel-sub-heading"><h4>Jogok</h4></div>
                    <table v-if="rulesShow" class="table table-bordered">
                      <thead>
                        <tr>
                          <th>Megnevezés</th>
                          <th>Érvényesség</th>
                          <th style="text-align:center">Engedélyezve</th>
                          <th style="text-align:center">Elsődleges</th>
                          <th v-show="jogSzerkesztes"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(rule, index) in form.card.rules">
                          <td>{{rule.name}}</td>
                          <td>{{rule.valid_from}} - {{rule.valid_to}}</td>
                          <td style="text-align:center"><i v-if="rule.public.selected" class="fa fa-check"></i><i v-if="!rule.public.selected" class="fa fa-times"></i></td>
                          <td style="text-align:center"><i v-if="rule.primary.selected" class="fa fa-check"></i><i v-if="!rule.primary.selected" class="fa fa-times"></i></td>
                          <td v-show="jogSzerkesztes">
                            <ul class="icon-list">
                              <li class="dropdown"><a class="dropdown-toggle" href="javascript:void(0)"><i class="fa fa-gear"></i></a>
                                <ul class="dropdown-menu">
                                  <li class="dropdown-header">Opciók</li>
                                  <li><a v-on:click="editRule(index)" href="javascript:void(0)" ><i class="fa fa-pencil"></i>Szerkeszt</a></li>
                                  <li><a v-on:click="ruleDel(index)" href="javascript:void(0)" ><i class="fa fa-trash-o"></i>Töröl</a></li>
                                </ul>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div v-else>
                      Nem található felvitt jog.
                    </div>

                  <button v-show="jogSzerkesztes" v-on:click="newRuleButtonClick" style="margin-top:30px" type="button" class="btn btn-primary"><i class="fa fa-plus"></i>Új jog hozzáadása</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <rulepopup v-if="rule_popup" :card="form.card" :card2rule="card2rule" :addrule="addRule" :hidepopup="hideRulePopup"></rulepopup>

    <div id="rf_popup" v-show="rf_popup" class="modal-content no-overlay" style="width: 500px">
      <div class="modal-header">
        <button v-on:click="rfpopupHide" type="button" class="close"><span aria-hidden="true">×</span></button>
          <h4 class="modal-title">Kártya RFID beolvasása</h4>
      </div>
      <div class="modal-body">
        <div style="text-align:center">
          <div style="margin-bottom: 20px">Érintse a kártyát az olvasóhoz</div>
          <svg class="preloader-svg" width="32" height="32" viewBox="0 0 66 66"><circle stroke="#dbdbdb" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle><circle class="preloader-svg-path" stroke="#666" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg>
          <div v-if="rf_popup_msg != ''" style="margin-top: 20px" class="alert alert-danger">{{ rf_popup_msg }}</div>
          <button v-if="rf_popup_msg != ''" class="btn btn-primary" type="button" v-on:click="setupDownload()"><i class="fa fa-download"></i>Kártyaolvasó illesztő letöltése</button>
        </div>
      </div>
      <div class="modal-footer">
        <button v-on:click="rfpopupHide" class="btn btn-large" type="button">Bezár</button>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';

import tplheader from './tpl_header.vue';
import tplLeftPanel from './tpl_leftpanel.vue';


Vue.component('rulepopup', {
  props: ['show','addrule','hidepopup','card2rule','card'],
  data: function() {
     return {
         rule: JSON.parse(JSON.stringify(this.card2rule)),
         rule_types: '',
         errors: []
     };
  },
  template: '<div class="modal-content no-overlay">\
        <div class="modal-header">\
          <button v-on:click="hide" type="button" class="close"><span aria-hidden="true">×</span></button>\
          <h4 class="modal-title">Jog</h4>\
        </div>\
        <div class="modal-body">\
          <inputbox id="valid_from" label="Érvényes-tól" v-bind:errors="errors" name="valid_from" v-model="rule.valid_from"></inputbox>\
          <inputbox id="valid_to" label="Érvényes-ig" v-bind:errors="errors" name="valid_to" v-model="rule.valid_to"></inputbox>\
          <combobox :change="ruleChange" id="rule_id" label="Jog" v-bind:errors="errors" name="rule_id" v-model="rule_types"></combobox>\
          <toggle id="public" label="Engedélyezve" v-bind:errors="errors" name="public" v-model="rule.public"></toggle>\
          <toggle v-show="showPrimaryToggle" id="primary" label="Elsődleges" v-bind:errors="errors" name="primary" v-model="rule.primary"></toggle>\
        </div>\
        <div class="modal-footer">\
          <button v-on:click="hide" class="btn btn-large" type="button">Bezár</button>\
          <button v-on:click="add" class="btn btn-primary btn-large" type="button">{{ buttonTitle }}</button>\
        </div>\
      </div>',
  computed: {
    buttonTitle: function() {
      return this.rule.guid == "" ? 'Hozzáad' : 'Módosít';
    },
    showPrimaryToggle: function() {
      return this.card.id == '' ? true : false;
    }
  },
  mounted: function() {
    var _this = this;

    $('#valid_from').datepicker({
      dateFormat: 'yy-mm-dd',
      changeMonth: true,
      changeYear: true,
      onSelect: function(dateText) {
        _this.rule.valid_from = dateText;
      }
    });

    $('#valid_to').datepicker({
      dateFormat: 'yy-mm-dd',
      changeMonth: true,
      changeYear: true,
      onSelect: function(dateText) {
        _this.rule.valid_to = dateText;
      }
    });

    this.$root.ajax('card/rule_types', {
      success: function(response) {
        _this.rule_types = response.rule_types;
        _this.rule_types.selected = _this.rule.rule_id;
      }
    });
  },
  methods: {
    ruleChange: function() {
      var _this = this;
      var valid_year = 0;

      this.rule_types.items.map(function(rule_type) {
        if (rule_type.value == _this.rule_types.selected && rule_type.valid_year != undefined)
          valid_year = rule_type.valid_year;
      });

      this.rule.rule_id = this.rule_types.selected;
      this.rule.valid_to = moment(this.valid_from).add(valid_year, 'Y').format('YYYY-MM-DD');
    },
    add: function() {
      var _this = this;

      if (this.card.owner_photo == '' && this.rule.rule_id == 1 && this.rule.primary.selected && this.rule.public.selected) {
        swal('Figyelem', 'Hallgatói kártya létrehozásához a kártyabirtokosnak fotóval kell rendelkeznie!', 'error');
        return false;
      }

      this.$root.ajax('card/addrule', {
        method: "POST",
        data: this.rule,
        success: function(response) {
          if (response.errors.length > 0) {
            _this.errors = response.errors;

          } else {
            _this.rule.name = response.name;
            _this.rule.rule_type_name = response.rule_type_name;
            _this.addrule(_this.rule);
          }
        }
      });
    },
    hide: function() {
      this.hidepopup();
    }
  }
});

export default {
  components: {
    tplheader,
    tplLeftPanel
  },
  data: function() {
    return {
      form: {
        card: {},
        statuses: [],
        owners: {
          items: [],
          selected: 0
        }
      },
      owner: {
        db_ad_username: '',
        gen_ad_username: '',
        student_active: false,
        show_student_status: false
      },
      photo_email: '',
      errors: [],
      rule_popup: false,
      card2rule: {},
      rf_popup: false,
      rf_popup_msg: '',
      cert_file_exists: 0,
      ad_canedit: false,
      is_save: false,
      is_print: false,
      is_print_enroll: false
    }
  },
  watch: {
    rule_popup: function(new_val, old_val) {
      if (new_val)
        this.rf_popup = false;
    },
    'form.card.rules': function() {
      var _this = this;

      this.owner.show_student_status = false;

      this.form.card.rules.map(function(rule) {
        if (rule.rule_type_name == 'STUDENT' && rule.primary.selected && rule.public.selected)
          _this.owner.show_student_status = true;
      });
    }
  },
  computed: {
    rulesShow: function() {
      if (typeof this.form.card.rules != "undefined") {
        return this.form.card.rules.length > 0 ? true : false;
      } else {
        return false;
      }
    },
    jogSzerkesztes: function() {
      return this.form.card.status_id == 7 || this.form.card.status_id == 8 || !this.$root.checkRule('card/edit/create') ? false : true
    },
  },
  mounted: function() {
    if (this.$root.socket.readyState === WebSocket.OPEN) {
      this.$root.socket.close();
    }

    var _this = this;

    this.$root.ajax('card/edit/' + (this.$route.query.id != undefined ? this.$route.query.id : 0) + '/' + (this.$route.query.owner_id != undefined ? this.$route.query.owner_id : 0), {
      success: function(response) {
        _this.form.card = response.card;

        // #-et leszedi
        if (_this.form.card.rf_id != undefined && _this.form.card.rf_id != '')
          _this.form.card.rf_id = _this.form.card.rf_id.substr(1);

        _this.owner.db_ad_username = response.owner.db_ad_username;

        if (response.owner.neptundata != undefined)
          _this.owner.neptundata = response.owner.neptundata;

        if (response.owner.felvetelt_nyert_kollegium != undefined)
          _this.owner.felvetelt_nyert_kollegium = response.owner.felvetelt_nyert_kollegium;

        if (response.owner.golyahet != undefined)
          _this.owner.golyahet = response.owner.golyahet;

        _this.form.statuses = response.statuses;
        _this.photo_email = 'Tisztelt ' + _this.form.card.name + '!\n\nA kártya készítéshez feltöltött fotója nem megfelelő, ezért nem tudjuk elfogadni kártya igénylését. Kérjük töltsön fel új fotót a https://user.sze.hu oldalon.\n\nA megfelelő fénykép az alábbi kritériumoknak felel meg:\n- szemmagasságból készül\n- fehér, homogén háttér előtt készül\n- látszik a fejtető és a váll is\n- 900x1080 pixel vagy nagyobb felbontású\n- színes\n- álló kép\n\nÜdvözlettel,\nEgyetemi Szolgáltató Központ és Kollégium';

        if (response.owners != undefined)
          _this.form.owners = response.owners;

        _this.isCertFileExists();

        if(_this.owner.db_ad_username == '' && (_this.form.card.status_id < 5 || _this.form.card.status_id == 9 || _this.form.card.status_id == 10)) {
          _this.form.card.rules.map(function(obj) {
            if (obj.primary.selected == true) {
              _this.getAdUsername(obj);
            }
          });
        }
      }
    });
  },
  methods: {
    enrollmentConfirmationPrint: function() {
      var _this = this;
      this.is_print_enroll = true;

      this.$root.ajax('card/enrollment_confirmation_print/' + this.form.card.id, {
        method: 'GET',
        success: function(response) {
          _this.is_print_enroll = false;

          if (response.filename == undefined) {
            swal('Figyelem', 'A bizonylat generálása nem sikerült, próbálja meg újra!', 'error');
          } else {
            printJS(response.filename);
          }
        }
      });
    },

    isCertFileExists: function() {
      var _this = this;

      if (this.form.card.card_number == undefined)
        return false;

      this.$root.ajax('card/is_cert_file_exists/' + _this.form.card.card_number, {
        method: 'GET',
        success: function(response) {
          _this.cert_file_exists = response.is_file;
        }
      });
    },

    printBizonylat: function() {
      printJS('bizonylatok/bizonylat_' + this.form.card.card_number + '.pdf');
    },

    badPhotoEmailSend: function() {
      var _this = this;

      this.$root.ajax('card/badphotoemail', {
        method: "POST",
        data: {
          id: this.form.card.id,
          msg: this.photo_email,
          name: this.form.card.name,
          email: this.form.card.email
        },
        success: function(response) {
          if (response.status == "OK") {
            if (response.success) {
              swal('Siker', 'Az email elküldve a felhasználónak!', 'success');
              _this.form.statuses.selected = _this.form.card.status_id = response.status_id;
            } else {
              swal('Figyelem', 'Az email küldés sikertelen, próbálja meg újra!', 'error');
            }
          }
        }
      });
    },

    ownerChange: function(val) {
      if (val != undefined) {
        this.form.card.owner_id = parseInt(val);

        var _this = this;

        this.$root.ajax('card/edit/' + '0/' + this.form.card.owner_id, {
          success: function(response) {
            if (response.owner.db_ad_username != '') {
              _this.owner.db_ad_username = response.owner.db_ad_username;
              _this.form.card.owner_ad_username = response.owner.db_ad_username;
              _this.form.card.owner_photo = response.card.owner_photo;
            }

            if (response.owner.neptundata != undefined)
              _this.owner.neptundata = response.owner.neptundata;

            if(_this.owner.db_ad_username == '' && (_this.form.card.status_id < 5 || _this.form.card.status_id == 9 || _this.form.card.status_id == 10)) {
              _this.form.card.rules.map(function(obj) {
                if (obj.primary.selected == true) {
                  _this.getAdUsername(obj);
                }
              });
            }
          }
        });
      }
    },

    guid: function() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      }
      return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    },

    ruleDel: function(index) {
      var is_delete = true;

      this.form.card.rules.map(function(rule, i) {
        if (i == index) {
          if (rule.primary.selected == true) {
            swal('Figyelem!', 'Az elsődleges jog nem törölhető!');
            is_delete = false;
          }
        }
      });

      if (is_delete)
        this.form.card.rules.splice(index, 1);
    },

    editRule: function(array_index) {
      var _this = this;

      this.form.card.rules.map(function(rule, i) {
        if (i == array_index) {
          _this.card2rule = rule;
        }
      });

      if (_this.card2rule.primaryc == 1 && this.form.card.id != '') {
        swal('Figyelem', 'Az elsődleges jog nem változtatható');
      }  else {
        this.showRulePopup();
      }
    },

    addRule: function(obj) {
      if (obj.primary.selected == true) {
        if(this.owner.db_ad_username == '' || this.owner.db_ad_username == null) {
          this.getAdUsername(obj);
        }
        this.form.card.rules.map(function(rule, i) {
          rule.primary.selected = false;
        });
      }

      if (obj.guid == "") {
        obj.guid = this.guid();
        this.form.card.rules.push(obj);

      } else {
        var arr = [];
        this.form.card.rules.map(function(rule, i) {
          if (rule.guid == obj.guid) {
            rule = obj;
          }
          arr.push(rule);
        });
        this.form.card.rules = arr;
      }

      this.card2rule = '';
      this.hideRulePopup();
    },

    hideRulePopup: function() {
      this.rule_popup = false;
      this.card2rule = '';
    },

    showRulePopup: function() {
      this.rule_popup = true;
    },

    newRuleButtonClick: function() {
      this.card2rule = {
        id: 0,
        name: "",
        primary: {value: 1, selected: false},
        public: {value: 1, selected: true},
        rule_id: 0,
        valid_from: moment().format('YYYY-MM-DD'),
        valid_to: "",
        guid: ""
      };
      this.showRulePopup();
    },

    getAdUsername: function(rule) {
      var _this = this;
      this.$root.ajax('card/getadusername', {
        method: 'POST',
        data: {
          rule: rule,
          owner_id: _this.form.card.owner_id
        },
        success: function(response) {
          if(rule.rule_type_name == 'OUTER' && (_this.form.card.status_id == 2 || _this.form.card.status_id == 4)) {
            _this.ad_canedit = true;
          } else {
            _this.ad_canedit = false;
          }
          _this.form.card.owner_ad_username = response.ad_username;
          _this.owner.gen_ad_username = response.ad_username;
        }
      });
    },

    statusChange: function() {
      this.form.card.status_id = this.form.statuses.selected;
    },

    save: function () {
      var _this = this;

      this.is_save = true;

      if(this.owner.gen_ad_username != '' && this.owner.gen_ad_username != this.form.card.owner_ad_username) {
        this.form.card.man_ad_username = true;
      } else {
        this.form.card.man_ad_username = false;
      }

      var post_data = JSON.parse(JSON.stringify(this.form.card));
      delete post_data.owner_photo;

      this.$root.ajax('card/save', {
        method: 'POST',
        data: post_data,
        success: function(response) {
          _this.is_save = false;

          _this.errors = [];

          if (response.errors.length == 0 && response.swal_error == undefined) {
            _this.$router.push({path: '/card/edit/', query: { id: response.card_id }});
            location.reload();
            if (response.bizonylat_fajl != undefined)
              printJS(response.bizonylat_fajl);
          } else {
            if (response.errors.length > 0) {
              _this.errors = response.errors;
            }
            if (response.swal_error != undefined) {
              swal('Figyelem!', response.swal_error, 'error');
            }
          }
        }
      });
    },

    beforePrint: function() {
      window.console.log("print előtt");
    },

    afterPrint:function() {
      window.console.log("print után");
    },

    print: function() {
      var _this = this;
      this.is_print = true;

      this.$root.ajax('card/print/'+this.form.card.id, {
        success: function(response) {
          _this.is_print = false;

          printJS('assets/img/cards/card.pdf');

          swal({
            title: "Sikerült a kártyanyomtatás?",
            type: "warning",
            showCancelButton: true,
            confirmButtonText: "Igen",
            cancelButtonText: "Nem",
            closeOnConfirm: true,
            closeOnCancel: true,
            animation: false
          }, function(isConfirm) {
            if (isConfirm) {
              _this.$root.ajax('card/change_status', {
                method: 'POST',
                data: {
                  status_id: 4,
                  card_id: _this.form.card.id
                },
                success: function(response) {
                  _this.form.statuses.selected = _this.form.card.status_id = 4;
                }
              });
            }
          });
        }
      });
    },

    rfpopupHide: function() {
      this.rf_popup = false;
      this.$root.socket.close();
    },

    rfpopupShow: function() {
      var _this = this;
      this.rf_popup_msg = '';
      this.rf_popup = true;
      $('#rf_popup').css({'top':(($(window).innerHeight() - $('#rf_popup').height()) / 2) - $('#rf_popup').height() / 2});

      try {
        _this.$root.socket = new WebSocket("wss://kmr-reader.uninet.hu:8080");

        _this.$root.socket.onclose = function (event) {
          if (event.code != 1000)
            _this.rf_popup_msg = 'Hiba történt az olvasás során: ' + event.code;
        };

        _this.$root.socket.onmessage = function (event) {
          if (event.data != undefined) {
            _this.$root.ajax('card/check_rf_id', {
              method: 'POST',
              data: {
                rf_id: event.data
              },
              success: function(response) {
                if (response.success == false) {
                  swal('Figyelem!', 'Az RFID már hozzá van rendelve egy kártyához', 'error');
                } else {
                  _this.form.card.rf_id = event.data;
                  _this.$root.socket.close();
                  _this.rfpopupHide();
                }
              }
            });
          }
        };
      } catch(err) {
        _this.rf_popup_msg = 'Hiba történt az olvasás során: ' + err;
      }
    },

    setupDownload () {
      window.open('/setup.exe');
    },

    changeCardStatus: function(status_id, msg) {
      var _this = this;
      var selejt = false;
      var requestAccept = false;

      if(this.form.card.status_id == 4 && status_id == 8) {
        selejt = true;
      }

      // Kártya igénylés elfogadása, és nyomtatási státuszba állítása
      if (status_id == 3)
        requestAccept = true;

      swal({
        title: "Biztos hogy megváltoztatja a kártya státuszát?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Igen",
        cancelButtonText: "Mégsem",
        closeOnConfirm: true,
        animation: false
      },
      function() {
        _this.$root.ajax('card/change_status', {
          method: 'POST',
          data: {
            status_id: status_id,
            card_id: _this.form.card.id,
            selejt: selejt,
            requestAccept: requestAccept ? 1 : 0
          },
          success: function(response) {
            if (response.error == undefined) {
              location.reload();
            } else {
              setTimeout(function() {
                swal('Figyelem!', response.error, 'error');
              }, 100);
            }
          }
        });
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// card.vue?d6db15ae